export interface PurchaseOrderLineStockAllocation {
  id: string;
  stockItemId: string;
  purchaseOrderLineId: string;
  stockNo: string;
  productId: string;
  productKey: string;
  productDescription: string;
  productType: string;
  gradeDescription: string;
  balance: number;
  allocated: number;
  totalAllocated: number;
  freeStock: number;
  issued: number;
  warehouseKey: string;
  warehouseDescription: string;
  locationKey: string;
  locationDescription: string;
  batchNo: string;
  qtyRequired: number;
  selected: boolean;
  canDelete: boolean;
  balanceImperial: number;
  allocatedImperial: number;
  totalAllocatedImperial: number;
  freeStockImperial: number;
  issuedImperial: number;
  qtyRequiredImperial: number;
}
